import { createIntl, createIntlCache, IntlShape, useIntl } from "react-intl";
import enTranslations from "src/translations/enTranslations.json";
import { intlOnError } from "src/utils/intlOnError";
import { intlDefaultRichTextElements } from "src/utils/intlRichTextElements";

/**
 * The app's current `intl`, reachable from code that renders React trees
 * outside the main root (e.g. the ui-components Notification api, which
 * mounts each notification into its own root). Kept in sync by
 * <GlobalIntlSync /> under the app's IntlProvider; starts as an English
 * instance so trees rendered before the app mounts — and unit tests — still
 * format correctly.
 */
const cache = createIntlCache();

let globalIntl: IntlShape = createIntl(
  {
    locale: "en",
    defaultLocale: "en",
    messages: enTranslations,
    defaultRichTextElements: intlDefaultRichTextElements,
    onError: intlOnError,
  },
  cache,
);

export const getGlobalIntl = (): IntlShape => globalIntl;

export const GlobalIntlSync = (): null => {
  globalIntl = useIntl();
  return null;
};
